import React from "react";

export default function FooterEditor({ footer, onChange }) {
  const set = (key, val) => onChange({ ...footer, [key]: val });
  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Footer / Contact</strong></legend>
      <label>Titre CTA
        <input value={footer.cta_heading || ""}
               onChange={(e) => set("cta_heading", e.target.value)}
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Texte CTA
        <textarea value={footer.cta_text || ""}
                  onChange={(e) => set("cta_text", e.target.value)}
                  rows={3}
                  style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
      <label>Type de contact
        <select value={footer.contact_type}
                onChange={(e) => set("contact_type", e.target.value)}
                style={{ width: "100%", padding: 8, margin: "4px 0 12px" }}>
          <option value="phone">Téléphone</option>
          <option value="email">Email</option>
          <option value="both">Les deux</option>
        </select>
      </label>
      {["phone", "both"].includes(footer.contact_type) && (
        <>
          <label>Téléphone (format international, ex: +33686582946)
            <input value={footer.phone || ""}
                   onChange={(e) => set("phone", e.target.value)}
                   style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
          </label>
          <label>Téléphone affiché (ex: 06 86 58 29 46)
            <input value={footer.phone_display || ""}
                   onChange={(e) => set("phone_display", e.target.value)}
                   style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
          </label>
        </>
      )}
      {["email", "both"].includes(footer.contact_type) && (
        <label>Email
          <input value={footer.email || ""}
                 onChange={(e) => set("email", e.target.value)}
                 placeholder="contact@exemple.fr"
                 style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
        </label>
      )}
      <label>Site web
        <input value={footer.website || ""}
               onChange={(e) => set("website", e.target.value)}
               placeholder="exemple.fr"
               style={{ width: "100%", padding: 8, margin: "4px 0 12px" }} />
      </label>
    </fieldset>
  );
}
